import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import Settings from "./pages/settings/Settings";
import CRM from "./pages/crm/CRM";
import PrivateRoute from "./utils/PrivateRoute";
import PublicRoute from "./utils/PublicRoute";
import ResetPassword from "./pages/settings/ResetPassword";
import AddUser from "./pages/settings/AddUser";
import AssignMicroapp from "./pages/settings/AssignMicroapp";
import ViewUser from "./pages/settings/ViewUser";
import AddLead from "./pages/crm/AddLead";
import API_BASE_URL from "./config";
import ViewLeads from "./pages/crm/ViewLeads";
import ViewLeadD from "./pages/crm/ViewLeadD";
import EditLead from "./pages/crm/editleads";
import EditLeadD from "./pages/crm/EditLeadD";
import Invoicing from "./pages/invoicing/Invoicing";
import BillingAddress from "./pages/settings/BillingAddress";
import ManageBrands from "./pages/settings/ManageBrands";
import CreateProformaStep1 from "./pages/invoicing/create-pi";
import PiAddLead from "./pages/invoicing/pi-addleads";
import CreateProformaItems from "./pages/invoicing/create-pi-items";
import PIView from "./pages/invoicing/pi-view";
import PIPrint from "./pages/invoicing/pi-print";
import ViewPI from "./pages/invoicing/view-pi";
import EditPI from "./pages/invoicing/edit-pi";
import EditPIItems from "./pages/invoicing/edit-pi-items";
import CreateTaxStandaloneStep1 from "./pages/invoicing/create-tax-standalone";
import CreateTaxItems from "./pages/invoicing/create-ti-items";
import TiAddLead from "./pages/invoicing/ti-addleads";
import TiView from "./pages/invoicing/ti-view";
import TIPrint from "./pages/invoicing/ti-print";
import CreateTaxFromPI from "./pages/invoicing/create-tax-from-pi";
import CreateTIFromPIItems from "./pages/invoicing/create-ti-from-pi-items";
import ViewTax from "./pages/invoicing/view-tax";
import EditTIItems from "./pages/invoicing/edit-ti-items";


function App() {
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/auth/check_session`, {
          credentials: "include",
        });
        const data = await res.json();

        if (data.status === "deactivated") {
          alert(
            "Your account has been deactivated. You will now be logged out.",
          );
          localStorage.clear(); // If you store anything
          sessionStorage.clear(); // Optional
          window.location.href = "/"; // Redirect to login
        }
      } catch (err) {
        console.error("Session check failed:", err);
      }
    }, 60000); // every 60 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/Settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/CRM"
          element={
            <PrivateRoute>
              <CRM />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/reset-password"
          element={
            <PrivateRoute>
              <ResetPassword />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/AddUser"
          element={
            <PrivateRoute>
              <AddUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/AssignMicroapp"
          element={
            <PrivateRoute>
              <AssignMicroapp />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/ViewUser"
          element={
            <PrivateRoute>
              <ViewUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/addlead"
          element={
            <PrivateRoute>
              <AddLead />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/viewleads"
          element={
            <PrivateRoute>
              <ViewLeads />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/ViewLeadD/:id"
          element={
            <PrivateRoute>
              <ViewLeadD />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/editleads"
          element={
            <PrivateRoute>
              <EditLead />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/crm/EditLeadD/:id"
          element={
            <PrivateRoute>
              <EditLeadD />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/Invoicing"
          element={
            <PrivateRoute>
              <Invoicing />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/BillingAddress"
          element={
            <PrivateRoute>
              <BillingAddress />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/settings/ManageBrands"
          element={
            <PrivateRoute>
              <ManageBrands />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/create-pi"
          element={
            <PrivateRoute>
              <CreateProformaStep1 />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/pi-addleads"
          element={
            <PrivateRoute>
              <PiAddLead />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/create-pi-items"
          element={
            <PrivateRoute>
              <CreateProformaItems />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/pi-view/:id"
          element={
            <PrivateRoute>
              <PIView />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/pi-print/:id"
          element={
            <PrivateRoute>
              <PIPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/view-pi"
          element={
            <PrivateRoute>
              <ViewPI />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/edit-pi"
          element={
            <PrivateRoute>
              <EditPI /> {/* Listing page */}
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/edit-pi-items/:id"
          element={
            <PrivateRoute>
              <EditPIItems /> {/* Editor page */}
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/create-tax-standalone"
          element={
            <PrivateRoute>
              <CreateTaxStandaloneStep1 />{" "}
              {/* Standalone Tax Invoice – Select Lead */}
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/create-ti-items"
          element={
            <PrivateRoute>
              <CreateTaxItems /> {/* Standalone Tax Invoice - Items Page */}
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/ti-addleads"
          element={
            <PrivateRoute>
              <TiAddLead />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/ti-view/:id"
          element={
            <PrivateRoute>
              <TiView />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/ti-print/:id"
          element={
            <PrivateRoute>
              <TIPrint />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/create-tax-from-pi"
          element={
            <PrivateRoute>
              <CreateTaxFromPI />
            </PrivateRoute>
          }
        />

        <Route
          path="/pages/invoicing/create-ti-from-pi-items/:piId"
          element={
            <PrivateRoute>
              <CreateTIFromPIItems />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/view-tax"
          element={
            <PrivateRoute>
              <ViewTax />
            </PrivateRoute>
          }
        />
        <Route
          path="/pages/invoicing/edit-ti-items/:id"
          element={
            <PrivateRoute>
              <EditTIItems />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
